import React from "react";
import { Box } from "@mui/material";
import { BankAccount } from "src/store/features/withdrawal.slice";
import { HoldingRes } from "src/store/features/api/generated";
import CountryOrCryptoFlag from "src/components/common/CountryOrCryptoFlag";
import { formatCurrency } from "src/utils/helpers/PriceAndUnitsHelpers";
import {
  StyledContainer,
  StyledItem,
  StyledLabel,
  StyledValue,
  ReviewSectionTitle,
} from "../common/styles/FiatWithdrawalStyled";

interface FiatWithdrawalStageReviewProps {
  selectedBankAccount: BankAccount | null;
  withdrawalAmount: number;
  defaultCurrencyHolding?: HoldingRes;
}

export function FiatWithdrawalStageReview({
  selectedBankAccount,
  withdrawalAmount,
  defaultCurrencyHolding,
}: FiatWithdrawalStageReviewProps) {
  return (
    <StyledContainer>
      <StyledItem sx={{ flexDirection: "column", alignItems: "flex-start", margin: 0 }}>
        <ReviewSectionTitle>Bank account</ReviewSectionTitle>
        <Box
          display="flex"
          alignItems="center"
          style={{
            paddingBottom: "28px",
          }}>
          <CountryOrCryptoFlag name={selectedBankAccount?.currency || ""} size={16} />
          <StyledValue>
            {selectedBankAccount
              ? `${
                  selectedBankAccount.currency
                } - Account ending in ${selectedBankAccount.accountNumber?.slice(-4)}`
              : "Not selected"}
          </StyledValue>
        </Box>
      </StyledItem>

      <StyledItem sx={{ flexDirection: "column", alignItems: "flex-start", margin: 0 }}>
        <ReviewSectionTitle>Amount to Withdraw</ReviewSectionTitle>
        <Box
          display="flex"
          alignItems="center"
          style={{
            paddingBottom: "28px",
          }}>
          <CountryOrCryptoFlag name={selectedBankAccount?.currency || ""} size={16} />
          <StyledValue>
            {withdrawalAmount} {selectedBankAccount?.currency ?? ""}
          </StyledValue>
        </Box>
      </StyledItem>
    </StyledContainer>
  );
}
